import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
const Index = ({ state, onChange, onSubmit, addRow, isFinalSubmitting, setIsFinalSubmitting, history }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table
                        className="assessment-table inspn-assessment-table"
                        cellSpacing={0}
                    >
                        <tbody>
                            <tr className="bghed">
                                <td className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s2 pd10 w150">
                                    <p>Date Received</p>
                                </td>
                                <td className="hd-s2 pd10 w200">
                                    <p>Name of Item</p>
                                </td>
                                <td className="hd-s2 pd10 w200">
                                    <p>To be handed over to vessel</p>
                                </td>
                                
                            </tr>

                            {state.map((item, index) => {
                                return (
                                    <tr>
                                        <td className="td-s1">
                                            <p className="s1">{index + 1}.</p>
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control"
                                                placeholder=""
                                                name={item.date_received.name}
                                                value={item.date_received.value}
                                                onChange={(e) => { onChange(item.date_received.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.name_of_item.name}
                                                value={item.name_of_item.value}
                                                onChange={(e) => { onChange(item.name_of_item.name, e.target.value, index) }}

                                            />
                                        </td>

                                        <td className="tb-input-value">
                                            <select
                                                className="form-control"
                                                placeholder=""
                                                name={item.to_be_handed_over_to_vessel.name}
                                                value={item.to_be_handed_over_to_vessel.value}
                                                onChange={(e) => { onChange(item.to_be_handed_over_to_vessel.name, e.target.value, index) }}

                                            >
                                                <option value={''}>(Yes/No)</option>
                                                <option value={'Yes'}>Yes</option>
                                                <option value={'No'}>No</option>

                                            </select>
                                        </td>

                                    </tr>
                                )
                            })}


                            
                        </tbody>
                    </table>
                   
                </div>
                
            </div>
        </div>
    )
}

export default withRouter(Index)